<button
  class="lty-btn lty-btn-primary {{ buttonClass }}"
  (click)="commissionModal.openModal()"
  i18n
>
  Lancer le commissionnement
</button>

<app-action-modal
  submitButtonClass="lty-btn-primary"
  #commissionModal
  [disabled]="clicked"
  (submitted)="initCommission()"
>
  <ng-container mainTitle i18n
    >Lancer un commissionnement pour cette police ?</ng-container
  >
  <ng-container subtitle i18n>Êtes-vous sûr ?</ng-container>
  <ng-container submitButtonLabel i18n>Confirmer</ng-container>
</app-action-modal>
